import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BomOptionsStepSeparateQuantity } from '../../../../bom/constants';
import FeedbackWrapper from '../../../common/FeedbackWrapper';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';
import QuantityNumericInput from '../QuantityNumericInput';
import StepNumber from '../StepNumber';
import { formatQuantity } from '../../../../utils/formatter';
import { getMinimumQuantity } from '../../../../price/selectors';
import { getQuantity } from '../../../../bom/selectors';
import { saveQuantity } from '../../../../bom/actions';
import { useDebouncedCallback } from 'use-debounce';

const CommonQuantityInput = ({ feedback, resetFeedback }) => {
  const dispatch = useDispatch();

  const miniQty = useSelector(getMinimumQuantity);
  const originalQuantity = useSelector(getQuantity);

  const [quantity, setQuantity] = useState(originalQuantity);

  const submitQuantity = () => {
    if (quantity !== originalQuantity) {
      dispatch(saveQuantity(quantity));
    }
  };

  const debouncedSubmitQuantity = useDebouncedCallback(() => {
    submitQuantity();
  }, 300);

  const handleBlur = () => {
    submitQuantity();
  };

  const handleChange = (value) => {
    setQuantity(value);
    resetFeedback('quantity');
    debouncedSubmitQuantity();
  };

  const handlePressEnter = () => {
    submitQuantity();
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label htmlFor="common-quantity-input">
        <StepNumber step={BomOptionsStepSeparateQuantity} />
        Quantity:
      </Form.Label>
      <div style={{ width: '200px' }}>
        <QuantityNumericInput
          aria-describedby="common-quantity-input-help"
          id="common-quantity-input"
          isInvalid={!!feedback['quantity']}
          value={quantity}
          onBlur={handleBlur}
          onChange={handleChange}
          onPressEnter={handlePressEnter}
        />
      </div>
      <Form.Text id="common-quantity-input-help" muted>{`Minimum quantity is ${formatQuantity(miniQty)}`}</Form.Text>
      {!!feedback['quantity'] && <FeedbackWrapper>{feedback['quantity']}</FeedbackWrapper>}
    </Form.Group>
  );
};

CommonQuantityInput.propTypes = {
  feedback: PropTypes.objectOf(PropTypes.string).isRequired,
  resetFeedback: PropTypes.func.isRequired,
};

export default CommonQuantityInput;
